<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>商品管理</el-breadcrumb-item>
            <el-breadcrumb-item>商品列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="10">
                    <el-input placeholder="请输入商品名称" clearable v-model="queryInfo.query" @clear="getGoodsList()">
                        <el-button slot="append" icon="el-icon-search" @click="getGoodsList()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4"><el-button type="primary" @click="AddGoods">添加商品</el-button></el-col>
            </el-row>
            <!--搜索与添加区域-->
            <!--商品列表区域-->
            <el-table :data="goodslist" style="width: 100%" stripe size="middle" height="600">
                <el-table-column label="ID" type="index" ></el-table-column>
                <!-- <el-table-column label="商品类型" prop="goods_class" width="300"></el-table-column> -->
                <el-table-column label="商品名称" prop="goods_name"  show-overflow-tooltip></el-table-column>
                <el-table-column label="商品价格" prop="goods_price"   width="100">
                    <template slot-scope="scope">
                        {{scope.row.goods_price}} 元
                    </template>
                </el-table-column>
                <el-table-column v-if="!isWebSite" label="租金" prop="goods_month"  width="230">
                    <template slot-scope="scope">
                        <span v-if="scope.row.goods_sign != '1'">{{scope.row.goods_month}} 元/月</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="!isWebSite" label="商品押金" prop="goods_deposit">
                    <template slot-scope="scope">
                        <span v-if="scope.row.goods_sign != '1'">{{scope.row.goods_deposit}} 元</span>
                    </template>
                </el-table-column>
                <el-table-column label="商品佣金" prop="goods_commission">
                    <template slot-scope="scope">
                        {{scope.row.goods_commission}} 元
                    </template>
                </el-table-column>
                <el-table-column label="商品图片" prop="goods_pic" >
                    <template slot-scope="scope">
                        <el-image 
                            style="width: 30px;vertical-align:middle;"
                            :src="require('@/assets/image/preview.png')"
                            :preview-src-list="previewPicList(scope.row.goods_pic)">
                        </el-image><span style="color: #ccc;">（{{ goodsPicCount(scope.row.goods_pic) }}）</span>
                        <!-- <el-image 
                            style="width: 100px; height: 100px"
                            :src="url" 
                            :preview-src-list="srcList">
                        </el-image> -->
                        <!-- <img v-if="scope.row.goods_pic.indexOf(',') !== -1" :src="imgURL + 'static/pics/' + scope.row.goods_pic.split(', ')[0].trim()" style="width:30px">
                        <img v-else :src="imgURL+'static/pics/'+scope.row.goods_pic" style="width:30px"> -->
                    </template>
                </el-table-column>
                <el-table-column label="租售模式" prop="goods_sign">
                    <template slot-scope="scope">
                       <el-tag v-if="scope.row.goods_sign=='1'"  type="success">仅出售</el-tag>
                       <el-tag v-else-if="scope.row.goods_sign=='2'"  type="danger">仅租赁</el-tag>
                       <el-tag v-else type="warning">既出售又租赁</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="是否显示" prop="goods_stock">
                    <template slot-scope="scope">
                       <el-tag v-if="scope.row.goods_index=='True'"  type="success">是</el-tag>
                       <el-tag v-else type="info">否</el-tag>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="赠送积分" prop="integral">
                </el-table-column> -->
                <el-table-column label="操作">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                        <!-- {{scope.row}} -->
                        <el-button type="success" icon="el-icon-edit" size="mini" @click="EditGoods(scope.row.id)"></el-button>
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelGoods(scope.row.id)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--商品列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[1, 5, 10, 20]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
        </el-card>
    </div>
</template>
<script>
export default {
    computed: {
        isWebSite() {
            return window.sessionStorage.getItem('site') === 'web'
        }
    },
    data(){
        return{
            addDialogVisible:false,
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 10
            },
            goodslist:[],
            total: 0,
            imgURL:this.GLOBAL.imgURL
        }
    },
    created() {
        this.getGoodsList()
    },
    mounted () {
        
    },
    methods:{
       goodsPicCount(pic) {
           if (pic == null) return 0
           if (Array.isArray(pic)) return pic.length
           return String(pic).split(',').filter((s) => s.trim()).length
       },
       previewPicList(pic) {
           if (pic == null) return []
           const list = Array.isArray(pic) ? [...pic] : String(pic).split(',').map((s) => s.trim()).filter(Boolean)
           return list.map((p) => (/^https?:\/\//i.test(String(p)) ? p : this.resolveStaticPic(p)))
       },
       async getGoodsList() {
           const { data: res} = await this.$http.get('goodslist/',{ params: this.queryInfo })
           if(res.status == 1 && res.data){
                const list = Array.isArray(res.data.list) ? res.data.list : []
                this.total = res.data.totalCount || 0
                this.goodslist = list.map(v => v.fields || {})
                for (let index = 0; index < list.length; index++) {
                    this.goodslist[index].id = list[index].pk
                }
            } else {
                this.total = 0
                this.goodslist = []
            }
       },
        handleSizeChange(newSize){
           this.queryInfo.pagesize = newSize
           this.getGoodsList()
       },
       handleCurrentChange(newPage){
           this.queryInfo.pagenum = newPage
           this.getGoodsList()
       },
       
       AddGoods(){
             this.$router.push({path: '/goodsadd'})
       },
       EditGoods(id){
            this.$router.push({
                path: `/goodsedit/${id}`
            })
       },
       async DelGoods(id){
        const confirmResult = await this.$confirm('是否要删除此商品吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).catch(err => err)

            if (confirmResult !== 'confirm'){
                return this.$message.info('已取消删除！')
            }
            const { data: res } = await this.$http.get('goodsdel/'+ id)
        
            if (res.status === 0) { 
                this.$message({message: '删除成功！',type: 'success'})
            }
            this.getGoodsList()
       },
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
</style>